import debug from 'debug'
import API from '@/api'
import events from 'Store/events'
import ChatLocalStorage from '@/api/chat'

const dbg = debug('store:chat:actions:')

export default {

  auth: function ({ commit }) {
    dbg('Init application: channels')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.authRocketChatUser()
        .then(resp => {
          commit('AUTH_ROCKET_USER', resp.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to authenticate to the chat'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  getChannels: function ({ commit }) {
    dbg('Init application: channels')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      const params = {
        offset: 0,
        limit: 50,
        total: 0
      }
      const sort = {
        sortProperty: ChatLocalStorage.channelsSortProperty(),
        sortDirection: ChatLocalStorage.channelsSortDirection()
      }
      commit('CHANNELS_LOADING', true)
      return API.getRocketChatChannels(params, sort)
        .then(channels => {
          const pagination = {
            offset: channels.data?.offset,
            limit: channels.data?.limit,
            total: channels.data?.total
          }
          commit('SET_PAGINATION_CHANNELS', pagination)
          commit('ADD_CHAT_CHANNELS', channels.data.data)
          commit('FILTER_CHANNELS_INIT')
          commit('CHANNELS_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get public channels'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  getMoreChannels: function ({ commit, state }) {
    dbg('Get more channels')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('CHANNELS_NEXT_PAGE')
      commit('CHANNELS_LOADING', true)
      return API.getRocketChatChannels(state.paginationChannels)
        .then(channels => {
          const pagination = {
            offset: channels.data?.offset,
            limit: channels.data?.limit,
            total: channels.data?.total
          }
          commit('SET_PAGINATION_CHANNELS', pagination)
          commit('ADD_CHAT_CHANNELS', channels.data.data)
          commit('CHANNELS_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get more channels'
          events.pubError(msg)
          reject(err.response.data)
        })
    })
  },

  getGroups: function ({ commit }) {
    dbg('Init application: channels')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('GROUPS_LOADING', true)
      const params = {
        offset: 0,
        limit: 50,
        total: 0
      }
      const sort = {
        sortProperty: ChatLocalStorage.groupsSortProperty(),
        sortDirection: ChatLocalStorage.groupsSortDirection()
      }
      return API.getRocketChatGroups(params, sort)
        .then(groups => {
          const pagination = {
            offset: groups.data?.offset,
            limit: groups.data?.limit,
            total: groups.data?.total
          }
          commit('SET_PAGINATION_GROUPS', pagination)
          commit('ADD_CHAT_GROUPS', groups.data.data)
          commit('FILTER_GROUPS_INIT')
          commit('GROUPS_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get private channels'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  getMoreGroups: function ({ commit, state }) {
    dbg('Get more groups')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('GROUPS_LOADING', true)
      commit('GROUPS_NEXT_PAGE')
      const sort = {
        sortProperty: ChatLocalStorage.groupsSortProperty(),
        sortDirection: ChatLocalStorage.groupsSortDirection()
      }
      return API.getRocketChatGroups(state.paginationGroups, sort)
        .then(groups => {
          const pagination = {
            offset: groups.data?.offset,
            limit: groups.data?.limit,
            total: groups.data?.total
          }
          commit('SET_PAGINATION_GROUPS', pagination)
          commit('ADD_CHAT_GROUPS', groups.data.data)
          commit('GROUPS_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get more groups'
          events.pubError(msg)
          reject(err.response.data)
        })
    })
  },

  getChannelMembers: function ({ commit }, roomId) {
    dbg('channel get public channel members')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.channelMembers(roomId)
        .then(channelMembers => {
          commit('ADD_CHAT_CHANNEL_MEMBERS', channelMembers.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get public channel members'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  getGroupMembers: function ({ commit }, roomId) {
    dbg('channel get public private members')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.groupMembers(roomId)
        .then(groupMembers => {
          commit('ADD_CHAT_GROUP_MEMBERS', groupMembers.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get public private members'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  getSmsDids: function ({ commit }) {
    dbg('get SMS DID')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.getSmsDids()
        .then(smsDids => {
          commit('ADD_SMS_DIDS', smsDids.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get SMS DID'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  updatePresence: function ({ commit }, presence) {
    commit('ADD_CHAT_PRESENCE', presence)
  },

  listPresences: function ({ commit }) {
    dbg('Init application: list chat presences')
    return API.listRocketChatPresences()
      .then(presence => {
        presence.data.users.forEach((user) => {
          commit('ADD_CHAT_PRESENCE', {
            userId: user.username, status: user.status, statusText: user.statusText
          })
        })
      })
      .catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get chat status'
        events.pubError(msg)
      })
  },

  // Deprecated, not in use as its now using sockets. Left here for commodity.
  getPresence: function ({ commit }, username) {
    dbg('get chat presence')
    return API.getRocketChatStatus(username)
      .then(presence => {
        if (presence.data) {
          // The requested user exist and is in the current user's realm
          commit('ADD_CHAT_PRESENCE', {
            userId: presence.data.username, status: presence.data.status, statusText: presence.data.message
          })
        }
      })
      .catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get chat status'
        events.pubError(msg)
      })
  },

  setPresence: function ({ commit }, presence) {
    dbg('set chat presence')
    return API.setRocketChatStatus(presence.status, presence.statusText)
      .then(() => {
        commit('ADD_CHAT_PRESENCE', {
          userId: presence.userId, status: presence.status, statusText: presence.statusText
        })
      })
      .catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get chat status'
        events.pubError(msg)
      })
  },

  getCustomPresenceTypes: function ({ commit }) {
    // TODO: Deal with custom statuses which are not yet supported.
    commit('SET_CHAT_PRESENCE_TYPES', [])
  },

  createCustomPresence: function ({ commit }, { name, type }) {
    dbg('Init application: create custom presence')
    return API.createRocketChatCustomStatus(name, type)
      .then(() => {
        commit('ADD_CHAT_PRESENCE_TYPE', { name, type })
      })
      .catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get chat status'
        events.pubError(msg)
      })
  },

  channelToggle: function ({ commit }, value) {
    dbg('Channel toggle value changed')
    commit('CHANNEL_TOGGLE', value)
  },

  groupToggle: function ({ commit }, value) {
    dbg('Group toggle value changed')
    commit('GROUP_TOGGLE', value)
  },

  getDirectMessages: function ({ commit }) {
    dbg('Get chat direct messages')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('DM_LOADING', true)
      const params = {
        offset: 0,
        limit: 50,
        total: 0
      }
      const sort = {
        sortProperty: ChatLocalStorage.dmSortProperty(),
        sortDirection: ChatLocalStorage.dmSortDirection()
      }
      return API.getRocketChatDirectConversations(params, sort)
        .then(directConversations => {
          commit('RESET_DIRECT_CONVERSATION')
          const pagination = {
            offset: directConversations.data?.offset,
            limit: directConversations.data?.limit,
            total: directConversations.data?.total
          }
          commit('SET_PAGINATION_DM', pagination)
          directConversations.data.data.forEach(dm => {
            commit('ADD_DIRECT_CONVERSATION', dm)
          })
          commit('FILTER_DM_INIT')
          commit('DM_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get direct messages'
          events.pubError(msg)
          const errorMsg = err?.response?.data || 'Failed to get direct messages'
          reject(errorMsg)
        })
    })
  },

  getMoreDirectMessages: function ({ commit, state }) {
    dbg('Get more chat direct messages')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('DM_LOADING', true)
      commit('DM_NEXT_PAGE')
      const sort = {
        sortProperty: ChatLocalStorage.dmSortProperty(),
        sortDirection: ChatLocalStorage.dmSortDirection()
      }
      return API.getRocketChatDirectConversations(state.paginationDm, sort)
        .then(directConversations => {
          const pagination = {
            offset: directConversations.data?.offset,
            limit: directConversations.data?.limit,
            total: directConversations.data?.total
          }
          commit('SET_PAGINATION_DM', pagination)
          directConversations.data.data.forEach(dm => {
            commit('ADD_DIRECT_CONVERSATION', dm)
          })
          commit('DM_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get direct messages'
          events.pubError(msg)
          reject(err.response.data)
        })
    })
  },

  getSmsMessages: function ({ commit, state }) {
    dbg('Get chat SMS messages')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('SMS_LOADING', true)
      const params = {
        offset: 0,
        limit: 50,
        total: 0
      }
      const sort = {
        sortProperty: ChatLocalStorage.smsSortProperty(),
        sortDirection: ChatLocalStorage.smsSortDirection()
      }
      return API.getRocketChatSmsConversations(params, sort)
        .then(smsConversations => {
          commit('RESET_SMS_CONVERSATION')
          const pagination = {
            offset: smsConversations.data?.offset,
            limit: smsConversations.data?.limit,
            total: smsConversations.data?.total
          }
          commit('SET_PAGINATION_SMS', pagination)
          smsConversations.data.data.forEach(sms => {
            commit('ADD_SMS_CONVERSATION', sms)
          })
          this.dispatch('chat/filterSMSInit')
          commit('SMS_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get SMS messages'
          events.pubError(msg)
          reject(err.response.data)
        })
    })
  },

  getMoreSmsMessages: function ({ commit, state }) {
    dbg('Get more chat SMS messages')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      commit('SMS_LOADING', true)
      commit('SMS_NEXT_PAGE')
      const sort = {
        sortProperty: ChatLocalStorage.smsSortProperty(),
        sortDirection: ChatLocalStorage.smsSortDirection()
      }
      return API.getRocketChatSmsConversations(state.paginationSms, sort)
        .then(smsConversations => {
          const pagination = {
            offset: smsConversations.data?.offset,
            limit: smsConversations.data?.limit,
            total: smsConversations.data?.total
          }
          commit('SET_PAGINATION_SMS', pagination)
          smsConversations.data.data.forEach(sms => {
            commit('ADD_SMS_CONVERSATION', sms)
          })
          commit('SMS_LOADING', false)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get SMS messages'
          events.pubError(msg)
          reject(err.response.data)
        })
    })
  },

  // open / close rename channel dialog
  openRenameChannelDialog: function ({ commit }) {
    dbg('Open channel rename dialog')
    commit('CHANNEL_RENAME_DIALOG')
  },

  // open / close rename group dialog
  openRenameGroupDialog: function ({ commit }) {
    dbg('Open group rename dialog')
    commit('GROUP_RENAME_DIALOG')
  },

  // sending state
  changeSendingState: function ({ commit }) {
    dbg('sending message')
    commit('SENDING')
  },

  // open / close new conversation dialog
  openDialog: function ({ commit }) {
    dbg('Open new conversation dialog')
    commit('OPEN_CONVERSATION_DIALOG')
  },

  // open / close delete members dialog
  openMembersChannelDialog: function ({ commit }) {
    dbg('Open members channel dialog')
    commit('OPEN_MEMBERS_CHANNEL_DIALOG')
  },

  // open / close delete group members dialog
  openMembersGroupDialog: function ({ commit }) {
    dbg('Open members group dialog')
    commit('OPEN_MEMBERS_GROUP_DIALOG')
  },

  // open / close available users drawe
  availableUsersDrawer: function ({ commit }) {
    dbg('Open / close available users drawer')
    commit('AVAILABLE_USERS_DRAWER')
  },

  // open / close confirm dialog
  closeChannelActionDialog: function ({ commit }) {
    dbg('Open confirm channel dialog')
    commit('CLOSE_CHANNEL_ACTION_DIALOG')
  },

  // open / close confirm dialog
  closeGroupActionDialog: function ({ commit }) {
    dbg('Open confirm group dialog')
    commit('CLOSE_GROUP_ACTION_DIALOG')
  },

  // open / close confirm dialog
  openChannelActionDialog: function ({ commit }, { options }) {
    dbg('Open confirm channel dialog')
    commit('OPEN_CHANNEL_ACTION_DIALOG', { options })
  },

  // open / close confirm dialog
  openGroupActionDialog: function ({ commit }, { options }) {
    dbg('Open confirm group dialog')
    commit('OPEN_GROUP_ACTION_DIALOG', { options })
  },

  // open / close delete conversation dialog
  openDeleteDirectChatDialog: function ({ commit }) {
    dbg('Open delete direct chat dialog')
    commit('OPEN_DELETE_DIRECT_CHAT_DIALOG')
  },

  getUsers: function ({ commit }) {
    dbg('New conversation: get chat users')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.getChatUsers()
        .then(users => {
          commit('ADD_USERS', users.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get chat users'
          events.pubError(msg)
          reject(err.response.data)
        })
    })
  },

  deleteChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('DELETE_CHANNEL')
  },

  joinChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('JOIN_CHANNEL')
  },

  addMemberToChannel: function ({ commit }, userId) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('ADD_MEMBER_TO_CHANNEL', userId)
  },

  restoreChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('RESTORE_CHANNEL')
  },

  kickMemberFromChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('KICK_MEMBER_FROM_CHANNEL')
  },

  addOwnerToChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('ADD_OWNER_CHANNEL')
  },

  removeOwnerFromChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('REMOVE_OWNER_CHANNEL')
  },

  openChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('OPEN_CHANNEL')
  },

  closeChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE_CHANNEL')
  },

  archiveChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('ARCHIVE_CHANNEL')
  },

  leaveChannel: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('LEAVE_CHANNEL')
  },

  renameChannel: function ({ commit }, name) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('RENAME_CHANNEL', name)
  },

  deleteGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('DELETE_GROUP')
  },

  addMemberToGroup: function ({ commit }, userId) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('ADD_MEMBER_TO_GROUP', userId)
  },

  restoreGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('RESTORE_GROUP')
  },

  kickMemberFromGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('KICK_MEMBER_FROM_GROUP')
  },

  addOwnerToGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('ADD_OWNER_GROUP')
  },

  removeOwnerFromGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('REMOVE_OWNER_GROUP')
  },

  openGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('OPEN_GROUP')
  },

  closeGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE_GROUP')
  },

  archiveGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('ARCHIVE_GROUP')
  },

  leaveGroup: function ({ commit }) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('LEAVE_GROUP')
  },

  renameGroup: function ({ commit }, name) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('RENAME_GROUP', name)
  },

  deleteDirectChat: function ({ commit }, roomId) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('DELETE_DIRECT_CHAT', roomId)
  },

  newConversation ({ state, commit }, data) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    API.newChatConversation(data.isSms, data.destinations, data.message, data.channelName, data.smsDestination, data.files, data.fromDid, data.channelType).then(resp => {
      commit('NEW_CONVERSATION', !state.openNewConversationDialog)
      if (data.destinations?.length > 1) {
        if (data.channelType.toLowerCase() === 'private') {
          this.dispatch('chat/getGroups')
        } else if (data.channelType.toLowerCase() === 'public') {
          this.dispatch('chat/getChannels')
        }
      } else {
        if (data.isSms) {
          this.dispatch('chat/getSmsMessages')
        } else {
          this.dispatch('chat/getDirectMessages')
        }
      }
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to create new conversation')
    }).finally(() => {
      this.dispatch('chat/changeSendingState')
    })
  },

  setContextMenuRoomId ({ commit }, roomId) {
    commit('SET_CONTEXT_MENU_ROOMID', roomId)
  },

  setContextMenuChannel ({ commit }, channel) {
    commit('SET_CONTEXT_MENU_CHANNEL', channel)
  },

  setContextMenuChannelAction ({ commit }, channelAction) {
    commit('SET_CONTEXT_MENU_CHANNEL_ACTION', channelAction)
  },

  setContextMenuMember ({ commit }, member) {
    commit('SET_CONTEXT_MENU_CHANNEL_MEMBER', member)
  },

  setContextMenuGroup ({ commit }, group) {
    commit('SET_CONTEXT_MENU_GROUP', group)
  },

  setContextMenuGroupAction ({ commit }, groupAction) {
    commit('SET_CONTEXT_MENU_GROUP_ACTION', groupAction)
  },

  setContextMenuGroupMember ({ commit }, member) {
    commit('SET_CONTEXT_MENU_GROUP_MEMBER', member)
  },

  resetMembersChannelDialog ({ commit }) {
    commit('SET_CONTEXT_MENU_CHANNEL', null)
    commit('OPEN_MEMBERS_CHANNEL_DIALOG')
  },

  resetMembersGroupDialog ({ commit }) {
    commit('SET_CONTEXT_MENU_GROUP', null)
    commit('OPEN_MEMBERS_GROUP_DIALOG')
  },

  resetConfirmDialog ({ commit }) {
    commit('SET_CONTEXT_MENU_ROOMID', null)
    commit('SET_CONTEXT_MENU_CHANNEL_ACTION', null)
    commit('SET_CONTEXT_MENU_CHANNEL_MEMBER', null)
    commit('CLOSE_CHANNEL_ACTION_DIALOG')
  },

  resetGroupConfirmDialog ({ commit }) {
    commit('SET_CONTEXT_MENU_ROOMID', null)
    commit('SET_CONTEXT_MENU_GROUP_ACTION', null)
    commit('SET_CONTEXT_MENU_GROUP_MEMBER', null)
    commit('CLOSE_GROUP_ACTION_DIALOG')
  },

  resetDeleteDirectChatDialog ({ commit }) {
    commit('SET_CONTEXT_MENU_ROOMID', null)
    commit('OPEN_DELETE_DIRECT_CHAT_DIALOG')
  },

  setUnreadDirectChat ({ commit }, { unread, index }) {
    commit('SET_UNREAD_DIRECT_CHAT', { unread, index })
  },

  setUnreadSmsChat ({ commit }, { unread, index }) {
    commit('SET_UNREAD_SMS_CHAT', { unread, index })
  },

  setUnreadChannel ({ commit }, { unread, index }) {
    commit('SET_UNREAD_CHANNEL', { unread, index })
  },

  setUnreadGroup ({ commit }, { unread, index }) {
    commit('SET_UNREAD_GROUP', { unread, index })
  },

  setOpenSmsChat ({ commit }, { open, index }) {
    commit('SET_OPEN_SMS', { open, index })
  },

  setOpenDmChat ({ commit }, { open, index }) {
    commit('SET_OPEN_DM', { open, index })
  },

  updateLastDirectConversationMessage ({ commit }, { params, index }) {
    commit('SET_DM_LAST_MESSAGE', { params, index })
  },

  updateLastSmsConversationMessage ({ commit }, { params, index }) {
    commit('SET_SMS_LAST_MESSAGE', { params, index })
  },

  updateLastChannelMessage ({ commit }, { params, index }) {
    commit('SET_CHANNEL_LAST_MESSAGE', { params, index })
  },

  updateLastGroupMessage ({ commit }, { params, index }) {
    commit('SET_GROUP_LAST_MESSAGE', { params, index })
  },

  selectRoom ({ commit }, room) {
    commit('SELECT_ROOM', room)
  },

  resetRoom ({ commit }) {
    commit('SELECT_ROOM', null)
  },

  selectDirectConversation ({ commit }, position) {
    commit('SELECT_DIRECT_MSG', position)
  },

  selectSmsConversation ({ commit }, position) {
    commit('SELECT_SMS_MSG', position)
  },

  selectChannel ({ commit }, position) {
    commit('SELECT_CHANNEL', position)
  },

  selectGroup ({ commit }, position) {
    commit('SELECT_GROUP', position)
  },

  filterSMS ({ commit }, smsFilters) {
    commit('FILTER_SMS', smsFilters)
  },

  filterSMSInit ({ commit }) {
    commit('FILTER_SMS_INIT')
  },

  setUnread ({ commit }, unread) {
    commit('UNREAD', unread)
  },

  setRealTimeAPI ({ commit }, realTimeAPI) {
    commit('REALTIME_API', realTimeAPI)
  },

  setTotalUnread ({ commit }) {
    commit('REFRESH_UNREAD')
  }
}
